<style scoped>



</style>

<template>
<div>
    <v-flex xs12 sm12>
      <sql v-if="dataSource.type == 'sql'" />
      <paste v-if="dataSource.type == 'paste'" />
      <upload-file v-if="dataSource.type == 'upload-file'" />
      <connection v-if="dataSource.group == 'connection'" />
    </v-flex>
</div>
</template>

<script>
import SpreadSheet from '@/components/data/SpreadSheet.vue';
import SQL from '@/components/data/SQL.vue';
import Paste from '@/components/data/Paste.vue';
import DataSource from '@/components/data/DataSource.vue';
import List from '@/components/data/List.vue';
import UploadFile from '@/components/data/UploadFile.vue';
import Connection from '@/components/data/Connection.vue';

import {
    createNamespacedHelpers
}
from 'vuex';
const {
    mapState, mapActions, mapGetters, mapMutations
} = createNamespacedHelpers('dataSources')

export default {
    data: function() {
        return {
            code: "/** INSERT SQL BELOW **/"
        };
    },
    methods: {
        editorInit: function(editor) {

        }
    },
    computed: {
        ...mapState(['types', 'dataSources', 'dataSource'])
    },
    components: {
      'spread-sheet': SpreadSheet,
      'sql' : SQL,
      'data-source': DataSource,
      'list': List,
      'paste': Paste,
      'upload-file': UploadFile,
      'connection': Connection
    }
}

</script>
